import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'src/app/shared/notifications.service';
import { ExportService } from 'src/app/shared/services/export-services';
import { saveAs } from 'file-saver';
import { Ng7BootstrapBreadcrumbService } from 'ng7-bootstrap-breadcrumb';

@Component({
  selector: 'app-relatorio-direitos',
  templateUrl: './relatorio-direitos.component.html',
  styleUrls: ['./relatorio-direitos.component.scss']
})

export class RelatorioDireitosComponent implements OnInit {
  isGeneratingReport = false;
  columnOptions = [
		{value: 'title', title: 'Titulo'},
		{value: 'format', title: 'Tipo de mídia'},
		{value: 'creator', title: 'Criador'},
		{value: 'credits', title: 'Crédito'},
    {value: 'publishAs', title: 'Publicador'},
    {value: 'category', title: 'Categoria'},
    {value: 'date', title: 'Data de criação'},
    {value: 'contracts.id', title: 'Número do contrato'},
    {value: 'datePermition', title: 'Periodo de permissões'},
  ];
  btnTitle = 'Exportar Relatório';

  constructor(
    private ng7BootstrapBreadcrumbService: Ng7BootstrapBreadcrumbService,
    private exportService: ExportService,
    private notificationService: NotificationsService
  ) { }

  ngOnInit(): void {
    const breadcrumbs = [
      { label: 'Sesc Digital', url: '/', params: [] },
      { label: 'Relatório de direitos e permissões', url: '', params: [] },]
	  
    this.ng7BootstrapBreadcrumbService.updateBreadcrumb(breadcrumbs);
  }

  export(form: any): void {
    let payload = {};

    if (form.searchTerm) {
      payload = {
        [form.column.value]: form.searchTerm,
      }
    } else if(form.createdDateStart && form.createdDateEnd) {
      payload = {
        createdDateStart: form.createdDateStart.format("YYYY-MM-DD"),
        createdDateEnd: form.createdDateEnd.format("YYYY-MM-DD"),
      }
    }else if(form.availabilityStart && form.availabilityEnd){
      payload = {
        availabilityStart: form.availabilityStart.format("YYYY-MM-DD"),
        availabilityEnd: form.availabilityEnd.format("YYYY-MM-DD"),
      }
    }
    

    this.isGeneratingReport = true;

    this.exportService.getContentExport(
      'CONTENT_TYPE_CATEGORY_SIMPLE', 'FORMAT_VIDEO,FORMAT_AUDIO,FORMAT_IMAGE,FORMAT_DOCUMENT', payload
    ).toPromise().then(
      response => {
        this.isGeneratingReport = false;
        saveAs(response.body, response.headers.get('Content-Disposition').split('=')[1]);
        this.notificationService.showSuccess('', 'Relatório gerado');
      },
      error => {
        this.isGeneratingReport = false;				
        this.notificationService.showError('Erro', 'Erro ao gerar relatório');
      }
    );
  }
}